import React from 'react';
import {useSequentialModalContext} from '@basicComponents/sequential-modal/context';

interface RegressProps {
  _bonusRate?: number;
}

export default function Regress({_bonusRate}: RegressProps) {
  const {goToNext} = useSequentialModalContext();
  return (
    <div>
      <div
        className="w-[321px] h-[427px] bg-full"
        onClick={goToNext}
        style={{
          backgroundImage: `url(${require('../../assets/regression.webp')})`,
        }}></div>
      <div className="flex justify-center mt-2">
        <div className="rounded-full border border-white p-[0.6875rem]">
          <svg
            viewBox="0 0 11 11"
            fill="none"
            onClick={goToNext}
            className="size-2.5">
            <path
              d="M8.31836 0.292969C8.70888 -0.097549 9.3419 -0.0975321 9.73242 0.292969C10.1229 0.683492 10.1229 1.31651 9.73242 1.70703L6.42676 5.0127L9.73242 8.31836C10.1229 8.70888 10.1229 9.3419 9.73242 9.73242C9.3419 10.1229 8.70888 10.1229 8.31836 9.73242L5.0127 6.42676L1.70703 9.73242C1.31651 10.1229 0.683494 10.1229 0.292969 9.73242C-0.0975113 9.3419 -0.0975395 8.70887 0.292969 8.31836L3.59863 5.0127L0.292969 1.70703C-0.097554 1.31651 -0.0975548 0.683492 0.292969 0.292969C0.683493 -0.097554 1.31651 -0.0975548 1.70703 0.292969L5.0127 3.59863L8.31836 0.292969Z"
              fill="white"
            />
          </svg>
        </div>
      </div>
    </div>
  );
}
